import { combineReducers } from 'redux';

import { userStatusReducer } from './userStatus';
import { stepReducer } from './step';
import { answerTextReducer } from './answerText';
import { ENewAnswerModalStep, INewAnswer } from '../../types/newAnswer';
import { TReduxActions } from '../../types/redux';
import { openReducer } from './open';
import { nameAnswerReducer } from './name';
import { isAnonymousAnswerReducer } from './isAnonymous';

export const defaultNewAnswer = {
  meta: {
    openId: null,
    step: ENewAnswerModalStep.Answer,
  },
  data: {
    isAnonymous: { value: null },
    name: { value: null },
    userStatus: { value: null },
    answer: { value: '' },
  },
};

export const newAnswerReducer = combineReducers<INewAnswer, TReduxActions>({
  meta: combineReducers({
    openId: openReducer,
    step: stepReducer,
  }),
  data: combineReducers({
    name: nameAnswerReducer,
    userStatus: userStatusReducer,
    answer: answerTextReducer,
    isAnonymous: isAnonymousAnswerReducer,
  }),
});
